const Text = (props) => {
  const { children } = props;
  return <div>{children}</div>;
};
export default Text;
